var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('FITOutstandingRequirement',_vm._b({attrs:{"accountType":_vm.accountType}},'FITOutstandingRequirement',_vm.properties,false))],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-432a6a02","hasScoped":false,"optionsId":"0","buble":{"objectAssign":"Object.assign","transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/Osm/LifePolicy/components/OutstandingRequirement.vue
// module id = null
// module chunks = 